import React from 'react';
import { logError } from '../helpers/errorLogger';

class ErrorBoundary extends React.Component {
    constructor(props) {
        super(props);
        this.state = { hasError: false };
    }

    static getDerivedStateFromError(error) {
        // Update state so the next render will show the fallback UI.
        const isLocalhost = Boolean(
            window.location.hostname === 'localhost' ||
            // [::1] is the IPv6 localhost address.
            window.location.hostname === '[::1]' ||
            // 127.0.0.1/8 is considered localhost for IPv4.
            window.location.hostname.match(
                /^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/
            )
        );

        if (isLocalhost) {
            return { hasError: false };
        }

        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("Global Error Caught by Boundary:", error, errorInfo);
        logError(error, {
            stack: error.stack,
            componentName: errorInfo.componentStack?.split("\n")[1]?.trim(),
            critical: true,
        });
    }

    render() {
        if (this.state.hasError && window.location.hostname !== 'localhost') {
            // Redirect to the error page instead of just rendering it
            // This ensures the URL changes and the application is reset
            window.location.href = "/page/error-404";
            return null;
        }

        return this.props.children;
    }
}

export default ErrorBoundary;
